import React from 'react'
import cx from 'classnames'
import { Form, Input } from 'antd'

import useTranslation from 'hooks/useTranslation'
import { passwordFormat } from 'utils/passwordFormat'

import Icon from 'components/Icon'
import { Text } from 'components/Typography'

import styles from './Password.module.scss'

type Props = {
  label?: React.ReactNode
  name: string
  placeholder?: string
}

const Password = (props: Props) => {
  const { label = 'Password', name, placeholder = 'Password' } = props
  const { t, copy } = useTranslation()
  return (
    <Form.Item noStyle shouldUpdate={(prev, cur) => prev[name] !== cur[name]}>
      {(form) => {
        const password = form.getFieldValue(name)
        return (
          <div className={styles.password}>
            <Form.Item
              name={name}
              label={label}
              validateStatus="success"
              rules={[{ pattern: passwordFormat }]}
              className={styles.formItem}
            >
              <Input.Password placeholder={placeholder} />
            </Form.Item>
            <ValidationItem
              format={/(?=.*[a-z])/}
              label={t(copy.Components.PasswordForm.ruleLowercase)}
              password={password}
            />
            <ValidationItem
              format={/(?=.*[A-Z])/}
              label={t(copy.Components.PasswordForm.ruleUppercase)}
              password={password}
            />
            <ValidationItem
              format={/(?=.*\d)/}
              label={t(copy.Components.PasswordForm.ruleNumber)}
              password={password}
            />
            <ValidationItem
              format={/(?=.*\W)/}
              label={t(copy.Components.PasswordForm.ruleSpecial)}
              password={password}
            />
            <ValidationItem
              format={/.{8,}/}
              label={t(copy.Components.PasswordForm.ruleLength)}
              password={password}
            />
          </div>
        )
      }}
    </Form.Item>
  )
}

type ValidationItemProps = {
  format: RegExp
  label: string
  password: string
}

const ValidationItem = (props: ValidationItemProps) => {
  const { format, label, password } = props
  const valid = password && format.test(password)
  return (
    <div className={styles.validationItem}>
      <Icon
        name="check"
        size="xs"
        type="white"
        className={cx(styles.icon, valid && styles.iconSuccess)}
      />
      <Text
        noLeading
        type={valid ? 'success' : 'light'}
        className={styles.label}
      >
        {label}
      </Text>
    </div>
  )
}

export default Password
